import { filter } from 'lodash';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  IconButton,
  Box,
  Link,
  Button
} from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { ClientListHead, ClientListToolbar, ClientMoreMenu } from '../_dashboard/clients';
import { useConstantsContext } from '../../context/constants_context';
import { useInvoiceContext } from '../../context/invoice_context';
import { useClientContext } from '../../context/client_context';
import { baseUrl } from '../../utils/constants';
import Controls from '../controls/Controls';

const TABLE_HEAD = [
  { id: 'medFundNo', label: 'Policy #', alignRight: false },
  { id: 'patientSuffix', label: 'Suffix', alignRight: false },
  { id: 'tarrifCode', label: 'Tarrif Code', alignRight: false },
  { id: 'usageDate', label: 'Usage Date', alignRight: false },
  { id: 'awarded', label: 'Awarded', alignRight: false },
  { id: '' }
];
// LimitGrouping nvarchar(50))
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) => _user.patientSuffix.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function LimitList() {
  // const { clientList } = useConstantsContext();
  // const { invoice, state, totalAmount } = useInvoiceContext();
  const { limitsList } = useClientContext();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('surname');
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' });
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(4);
  const navigate = useNavigate();

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = limitsList.map((n) => n.surname);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - limitsList.length) : 0;
  console.log('limitsList list in limitsList 01', limitsList);
  const filteredUsers = applySortFilter(limitsList, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;
  console.log('client list in client', limitsList);
  return (
    <Container>
      <Typography variant="h6" gutterBottom>
        Claims Summary...
      </Typography>
      <Card>
        {/* <ClientListToolbar
          numSelected={selected.length}
          filterName={filterName}
          onFilterName={handleFilterByName}
        /> */}

        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={limitsList.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                onSelectAllClick={handleSelectAllClick}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    const { medFundNo, patientSuffix, tarrifCode, usageDate, awarded } = row;
                    const isItemSelected = selected.indexOf(medFundNo) !== -1;

                    return (
                      <TableRow
                        hover
                        key={medFundNo}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />
                        <TableCell align="left">{medFundNo}</TableCell>
                        <TableCell align="left">{patientSuffix}</TableCell>
                        <TableCell align="left">{tarrifCode}</TableCell>
                        <TableCell align="left">{usageDate}</TableCell>
                        <TableCell align="left">{awarded}</TableCell>
                        <TableCell align="right">
                          <IconButton>
                            <DeleteForeverIcon sx={{ color: '#f44336' }} />
                          </IconButton>
                          <IconButton>
                            <VisibilityIcon sx={{ color: '#03a9f4' }} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Scrollbar>

        <TablePagination
          rowsPerPageOptions={[4, 8, 12]}
          component="div"
          count={limitsList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
      {/* {!!limitsList.length && (
        <Box p={2.5}>
          <Button
            variant="contained"
            color="primary"
            sx={{
              mb: '0.75rem',
              height: '40px'
            }}
            fullWidth
            // onClick={() => saveInvoiceData()}
          >
            Process Now ($ {totalAmount.toFixed(2)});
          </Button>
        </Box>
      )} */}
      <Controls.Notification notify={notify} setNotify={setNotify} />
    </Container>
  );
}
